module.exports = __webpack_public_path__ + "fonts/qtzaintext.9cf0254e.woff";